import { SnapchatLogo } from '@/assets/svg';
import BaseSocialModal from './BaseSocialModal';

export default class Snapchat extends BaseSocialModal {
  constructor(props) {
    super(props, 'Snapchat');
    this.logo = SnapchatLogo;
  }

  render() {
    return this.renderSocialModal();
  }
}
